var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 978,
    height: 733,
    viewBox: "0 0 978 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_719_78054)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_719_78054)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1041.6 466.733C1041.38 466.737 1041.18 466.683 1040.99 466.577L803.256 329.172C798.861 326.641 796.45 323.196 796.45 319.438C796.45 315.681 798.861 312.274 803.256 309.704L958.047 220.151C961.644 218.068 963.627 215.382 963.627 212.578C963.627 209.775 961.683 207.069 958.047 205.005L695.946 53.6612C691.506 51.4147 686.601 50.2442 681.626 50.2442C676.651 50.2442 671.746 51.4147 667.305 53.6612L579.401 104.473C575.804 106.556 573.82 109.242 573.82 112.046C573.82 114.849 575.765 117.555 579.401 119.619L710.062 195.174C714.456 197.705 716.867 201.131 716.867 204.908C716.867 208.685 714.456 212.072 710.062 214.642L514.673 327.479C506.098 332.443 492.157 332.443 483.563 327.479L353.874 252.488C353.728 252.411 353.598 252.305 353.494 252.177C353.39 252.049 353.312 251.901 353.266 251.743C353.221 251.584 353.207 251.418 353.227 251.254C353.247 251.09 353.3 250.931 353.383 250.788C353.465 250.645 353.576 250.52 353.708 250.421C353.84 250.322 353.99 250.25 354.151 250.211C354.311 250.171 354.478 250.165 354.64 250.191C354.803 250.218 354.959 250.277 355.099 250.366L484.827 325.376C489.267 327.622 494.172 328.793 499.147 328.793C504.122 328.793 509.027 327.622 513.467 325.376L708.857 212.462C712.454 210.398 714.417 207.692 714.417 204.889C714.417 202.085 712.473 199.399 708.857 197.316L578.176 121.78C573.801 119.249 571.39 115.803 571.39 112.046C571.39 108.288 573.801 104.901 578.176 102.312L666.08 51.5002C674.655 46.5359 688.596 46.5359 697.19 51.5002L959.291 203C963.666 205.531 966.077 208.977 966.077 212.734C966.077 216.491 963.666 219.879 959.291 222.468L804.48 312.021C800.883 314.085 798.92 316.791 798.92 319.594C798.92 322.397 800.864 325.084 804.48 327.167L1042.18 464.572C1042.32 464.651 1042.44 464.756 1042.54 464.882C1042.63 465.008 1042.71 465.152 1042.75 465.306C1042.79 465.46 1042.8 465.621 1042.78 465.779C1042.76 465.937 1042.71 466.089 1042.63 466.227C1042.51 466.388 1042.35 466.518 1042.17 466.606C1041.99 466.694 1041.8 466.738 1041.6 466.733Z",
    fill: "url(#paint0_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.284 398.556C925.071 398.559 924.861 398.505 924.676 398.399C924.491 398.292 924.339 398.138 924.234 397.953C924.07 397.674 924.023 397.341 924.103 397.027C924.183 396.714 924.384 396.444 924.662 396.278L1215.01 228.075C1219.97 225.194 1222.69 221.475 1222.69 217.543C1222.69 213.61 1219.97 209.892 1215.01 207.03L993.745 79.1253C983.032 72.9345 965.63 72.9345 954.858 79.1253L905.49 107.724C905.21 107.871 904.884 107.904 904.58 107.816C904.277 107.728 904.018 107.526 903.86 107.252C903.702 106.978 903.656 106.653 903.731 106.345C903.807 106.038 903.998 105.771 904.265 105.602L953.711 77.0033C965.085 70.4426 983.576 70.4426 994.951 77.0033L1216.24 204.927C1221.97 208.237 1225.12 212.715 1225.12 217.543C1225.12 222.371 1221.97 226.868 1216.24 230.177L925.887 398.381C925.706 398.494 925.497 398.555 925.284 398.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.517 732.744C429.423 732.871 423.397 731.43 418.018 728.558L101.903 545.832C97.0034 542.989 94.3007 539.154 94.3007 535.007C94.3007 530.861 97.0034 527.025 101.903 524.203L209.718 461.905C219.44 456.318 234.995 456.318 244.717 461.905L444.15 577.136C453.133 582.315 467.736 582.315 476.719 577.136L745.741 421.606C749.863 419.231 752.138 416.136 752.138 412.904C752.138 409.672 749.863 406.577 745.741 404.182L666.333 358.257C657.35 353.059 642.748 353.059 633.765 358.257L477.924 448.297C468.202 453.865 452.647 453.865 442.926 448.297L225.293 322.475C216.31 317.297 201.707 317.297 192.725 322.475L-39.5883 456.785C-39.8591 456.951 -40.1831 457.008 -40.494 456.942C-40.8048 456.877 -41.0791 456.696 -41.2605 456.434C-41.3403 456.297 -41.3921 456.144 -41.4128 455.986C-41.4336 455.828 -41.4228 455.668 -41.3812 455.514C-41.3397 455.36 -41.2681 455.216 -41.1706 455.09C-41.0731 454.964 -40.9517 454.858 -40.8133 454.78L191.519 320.451C201.241 314.883 216.796 314.863 226.518 320.451L444.15 446.253C453.114 451.451 467.736 451.451 476.699 446.253L632.462 356.213C642.184 350.645 657.739 350.645 667.461 356.213L746.966 402.177C751.866 405.02 754.568 408.855 754.568 413.001C754.568 417.148 751.866 420.983 746.966 423.806L477.924 579.258C468.202 584.845 452.647 584.845 442.926 579.258L243.511 463.988C234.528 458.79 219.926 458.79 210.943 463.988L103.128 526.286C99.0061 528.661 96.7312 531.756 96.7312 534.988C96.7312 538.22 99.0061 541.315 103.128 543.709L419.224 726.456C428.207 731.634 442.809 731.634 451.792 726.456L860.77 489.997C860.909 489.909 861.065 489.85 861.228 489.823C861.391 489.796 861.557 489.803 861.718 489.842C861.878 489.882 862.029 489.953 862.16 490.053C862.292 490.152 862.403 490.277 862.486 490.42C862.568 490.563 862.621 490.721 862.641 490.885C862.661 491.049 862.648 491.216 862.602 491.374C862.556 491.533 862.479 491.681 862.374 491.809C862.27 491.937 862.141 492.042 861.995 492.119L453.017 728.558C447.637 731.43 441.612 732.871 435.517 732.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.964 642.237C737.751 642.234 737.542 642.173 737.361 642.062L669.308 602.775C669.148 602.707 669.005 602.606 668.888 602.477C668.77 602.349 668.681 602.198 668.627 602.033C668.572 601.868 668.553 601.693 668.571 601.52C668.589 601.347 668.644 601.18 668.732 601.03C668.819 600.88 668.937 600.75 669.079 600.649C669.22 600.548 669.382 600.478 669.552 600.445C669.722 600.411 669.898 600.414 670.067 600.453C670.236 600.492 670.395 600.567 670.533 600.673L738.586 639.959C738.725 640.04 738.847 640.147 738.944 640.275C739.042 640.404 739.112 640.55 739.152 640.706C739.192 640.862 739.2 641.025 739.177 641.184C739.153 641.343 739.097 641.496 739.014 641.634C738.909 641.819 738.756 641.973 738.571 642.08C738.387 642.186 738.177 642.24 737.964 642.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.121 210.009C551.856 210.003 551.599 209.91 551.391 209.746C551.182 209.581 551.033 209.354 550.965 209.097C550.897 208.84 550.914 208.567 551.014 208.321C551.114 208.075 551.291 207.868 551.518 207.731L640.959 155.965C641.099 155.877 641.254 155.818 641.417 155.791C641.58 155.765 641.747 155.771 641.907 155.811C642.067 155.85 642.218 155.922 642.35 156.021C642.482 156.12 642.593 156.245 642.675 156.388C642.758 156.531 642.811 156.689 642.831 156.853C642.85 157.017 642.837 157.184 642.791 157.342C642.745 157.501 642.668 157.649 642.564 157.777C642.459 157.905 642.33 158.011 642.184 158.087L552.646 209.833C552.488 209.934 552.308 209.994 552.121 210.009Z",
    fill: "url(#paint1_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.016 232.786H512.728C512.404 232.786 512.092 232.657 511.862 232.427C511.633 232.197 511.503 231.885 511.503 231.56V208.198C511.509 207.876 511.64 207.569 511.869 207.343C512.098 207.118 512.407 206.991 512.728 206.991H553.035C553.357 206.991 553.665 207.118 553.894 207.343C554.124 207.569 554.255 207.876 554.26 208.198V231.56C554.263 231.721 554.233 231.882 554.172 232.032C554.111 232.182 554.021 232.318 553.907 232.433C553.793 232.547 553.657 232.637 553.507 232.698C553.357 232.759 553.197 232.789 553.035 232.786H553.016ZM513.914 230.353H551.81V209.483H513.914V230.353Z",
    fill: "url(#paint2_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.142 678.662C437.634 678.804 430.212 677.029 423.579 673.503C417.591 670.037 414.285 665.365 414.285 660.323C414.285 655.281 417.591 650.589 423.579 647.162C435.459 640.29 454.806 640.29 466.705 647.162C472.694 650.628 475.999 655.3 475.999 660.323C475.999 665.346 472.694 670.057 466.705 673.503C460.072 677.029 452.651 678.804 445.142 678.662ZM445.142 644.398C438.054 644.266 431.049 645.941 424.785 649.265C419.593 652.283 416.716 656.215 416.716 660.323C416.716 664.431 419.593 668.383 424.785 671.381C436.004 677.883 454.261 677.863 465.5 671.381C470.691 668.383 473.569 664.45 473.569 660.323C473.569 656.196 470.691 652.283 465.48 649.265C459.224 645.938 452.225 644.263 445.142 644.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.818 635.112C362.303 635.254 354.875 633.479 348.235 629.953C342.246 626.487 338.96 621.815 338.96 616.773C338.96 611.731 342.246 607.039 348.235 603.613C360.135 596.74 379.481 596.74 391.381 603.613C397.369 607.078 400.655 611.75 400.655 616.773C400.655 621.796 397.369 626.507 391.381 629.953C384.746 633.476 377.326 635.252 369.818 635.112ZM369.818 600.848C362.735 600.716 355.736 602.391 349.479 605.715C344.269 608.733 341.41 612.665 341.41 616.773C341.41 620.881 344.269 624.833 349.479 627.85C360.698 634.333 378.956 634.333 390.175 627.85C395.386 624.833 398.244 620.9 398.244 616.773C398.244 612.646 395.386 608.733 390.175 605.715C383.906 602.385 376.893 600.71 369.798 600.848H369.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.473 591.562C286.963 591.714 279.54 589.938 272.91 586.403C266.921 582.938 263.616 578.265 263.616 573.243C263.616 568.22 266.921 563.509 272.91 560.063C284.79 553.19 304.156 553.19 316.036 560.063C322.025 563.528 325.33 568.2 325.33 573.243C325.33 578.285 322.025 582.977 316.036 586.403C309.406 589.938 301.983 591.714 294.473 591.562ZM294.473 557.318C287.392 557.177 280.393 558.845 274.135 562.165C268.924 565.183 266.046 569.115 266.046 573.243C266.046 577.37 268.924 581.283 274.135 584.3C285.354 590.783 303.612 590.783 314.831 584.3C320.022 581.283 322.9 577.35 322.9 573.243C322.9 569.135 320.022 565.183 314.831 562.165C308.565 558.847 301.56 557.179 294.473 557.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.129 547.934C211.619 548.088 204.195 546.312 197.566 542.775C191.558 539.31 188.272 534.637 188.272 529.615C188.272 524.592 191.558 519.881 197.566 516.435C209.446 509.563 228.793 509.563 240.692 516.435C246.681 519.9 249.986 524.573 249.986 529.615C249.986 534.657 246.681 539.349 240.692 542.775C234.061 546.308 226.639 548.084 219.129 547.934ZM219.129 513.69C212.04 513.548 205.032 515.224 198.772 518.557C193.561 521.555 190.702 525.488 190.702 529.615C190.702 533.742 193.561 537.655 198.772 540.673C209.991 547.155 228.248 547.155 239.467 540.673C244.678 537.655 247.536 533.722 247.536 529.615C247.536 525.507 244.678 521.555 239.467 518.557C233.207 515.248 226.206 513.599 219.129 513.768V513.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.109 518.732C239.841 518.73 239.582 518.641 239.371 518.478C239.159 518.315 239.006 518.087 238.936 517.829C238.865 517.571 238.881 517.297 238.98 517.049C239.08 516.801 239.257 516.592 239.486 516.454L288.757 487.973C289.038 487.81 289.372 487.766 289.685 487.85C289.999 487.934 290.266 488.139 290.429 488.42C290.509 488.558 290.56 488.711 290.581 488.869C290.602 489.027 290.591 489.187 290.55 489.341C290.508 489.495 290.436 489.639 290.339 489.765C290.241 489.891 290.12 489.996 289.982 490.075L240.711 518.732C240.513 518.777 240.307 518.777 240.109 518.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.201 695.326C509.981 695.326 509.766 695.265 509.578 695.151L468.747 671.244C468.509 671.063 468.346 670.801 468.288 670.508C468.23 670.214 468.282 669.91 468.432 669.651C468.582 669.393 468.822 669.199 469.106 669.105C469.389 669.011 469.697 669.024 469.972 669.142L510.803 693.048C511.081 693.215 511.282 693.484 511.362 693.797C511.442 694.111 511.395 694.444 511.231 694.723C511.124 694.902 510.973 695.051 510.793 695.156C510.613 695.262 510.409 695.32 510.201 695.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.29 665.54H737.963C737.642 665.535 737.335 665.404 737.11 665.174C736.884 664.945 736.758 664.636 736.758 664.314V640.952C736.755 640.793 736.785 640.635 736.844 640.487C736.904 640.34 736.993 640.205 737.105 640.093C737.218 639.98 737.352 639.891 737.499 639.832C737.646 639.772 737.804 639.743 737.963 639.745H778.29C778.611 639.745 778.92 639.872 779.149 640.097C779.378 640.323 779.509 640.63 779.515 640.952V664.314C779.515 664.639 779.386 664.951 779.156 665.181C778.926 665.411 778.614 665.54 778.29 665.54ZM739.188 663.107H777.162V642.237H739.188V663.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.757 492.275H861.45C861.125 492.275 860.814 492.146 860.584 491.916C860.354 491.686 860.225 491.374 860.225 491.049V467.687C860.223 467.528 860.252 467.37 860.312 467.222C860.371 467.074 860.46 466.94 860.573 466.828C860.685 466.715 860.819 466.626 860.966 466.566C861.114 466.507 861.272 466.477 861.431 466.48H901.757C902.078 466.48 902.387 466.606 902.616 466.832C902.845 467.058 902.977 467.365 902.982 467.687V491.049C902.979 491.378 902.846 491.693 902.612 491.925C902.384 492.149 902.077 492.275 901.757 492.275ZM862.714 489.842H900.61V468.972H862.714V489.842Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.555 592.71L108.3 545.598C106.531 544.586 106.764 542.795 108.786 541.704L132.683 527.882L220.393 578.499L196.497 592.302C195.451 592.904 194.279 593.255 193.074 593.326C191.869 593.397 190.665 593.186 189.555 592.71Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.148 528.622V512.405H278.763L220.198 478.55C219.311 478.152 218.343 477.966 217.371 478.007C216.399 478.047 215.45 478.313 214.599 478.784L156.268 512.483H130.038V528.758C130.071 529.044 130.176 529.317 130.343 529.552C130.509 529.787 130.732 529.976 130.991 530.101L214.987 578.655C215.875 579.052 216.843 579.238 217.815 579.198C218.787 579.157 219.736 578.891 220.587 578.421L303.787 530.413C304.146 530.253 304.459 530.005 304.697 529.692C304.935 529.379 305.09 529.011 305.148 528.622Z",
    fill: "url(#paint3_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.007 562.457L131.01 513.904C129.572 513.086 129.766 511.626 131.419 510.672L214.599 462.586C215.449 462.112 216.398 461.843 217.371 461.803C218.343 461.762 219.312 461.95 220.198 462.353L304.195 510.945C305.634 511.782 305.439 513.223 303.787 514.177L220.607 562.263C219.756 562.737 218.804 563.002 217.83 563.036C216.857 563.07 215.889 562.872 215.007 562.457Z",
    fill: "url(#paint4_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.24 556.773L140.79 513.748C139.527 513.008 139.682 511.801 141.14 510.867L214.89 468.252C215.641 467.827 216.482 467.586 217.344 467.548C218.205 467.511 219.064 467.679 219.848 468.037L294.298 511.081C295.562 511.821 295.406 513.028 293.948 513.943L220.218 556.578C219.46 556.996 218.616 557.231 217.752 557.264C216.888 557.298 216.028 557.13 215.24 556.773Z",
    fill: "url(#paint5_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.493 553.171L147.187 513.631C146.021 512.95 146.157 511.782 147.518 511.003L215.24 471.834C215.932 471.45 216.703 471.233 217.492 471.199C218.282 471.165 219.069 471.316 219.79 471.639L288.193 511.178C289.359 511.86 289.223 513.125 287.862 513.826L220.121 552.976C219.421 553.377 218.636 553.604 217.83 553.638C217.025 553.672 216.224 553.512 215.493 553.171Z",
    fill: "#FFCB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.817 654.872C352.96 654.872 337.113 651.075 325.194 644.184C312.925 637.097 306.178 627.578 306.178 617.357C306.178 607.136 312.925 597.597 325.194 590.511C349.79 576.299 389.825 576.299 414.421 590.511C426.69 597.597 433.437 607.136 433.437 617.357C433.437 627.578 426.69 637.097 414.421 644.184C402.502 651.114 386.675 654.872 369.817 654.872ZM369.817 582.159C354.087 582.159 338.357 585.624 326.38 592.535C314.87 599.193 308.531 607.993 308.531 617.357C308.531 626.721 314.87 635.501 326.38 642.159C337.891 648.817 353.368 652.536 369.837 652.536C386.306 652.536 401.705 648.856 413.274 642.159C424.843 635.462 431.123 626.702 431.123 617.357C431.123 608.012 424.785 599.193 413.274 592.535C401.277 585.624 385.547 582.159 369.798 582.159H369.817Z",
    fill: "url(#paint6_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.798 644.184C395.431 644.184 416.21 632.173 416.21 617.357C416.21 602.541 395.431 590.53 369.798 590.53C344.165 590.53 323.386 602.541 323.386 617.357C323.386 632.173 344.165 644.184 369.798 644.184Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.651 597.11V584.495H422.296C418.99 580.132 414.803 576.517 410.007 573.885C387.803 561.055 351.813 561.055 329.608 573.885C324.812 576.517 320.625 580.132 317.32 584.495H312.964V597.13C312.964 605.52 318.506 613.931 329.608 620.355C351.813 633.184 387.803 633.184 410.007 620.355C421.11 613.931 426.651 605.52 426.651 597.11Z",
    fill: "url(#paint7_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 617.357C401.186 617.357 426.632 602.644 426.632 584.495C426.632 566.346 401.186 551.633 369.798 551.633C338.409 551.633 312.964 566.346 312.964 584.495C312.964 602.644 338.409 617.357 369.798 617.357Z",
    fill: "url(#paint8_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.296 584.008V566.779H418.271C415.224 562.767 411.36 559.449 406.935 557.045C386.422 545.189 353.193 545.189 332.68 557.045C328.256 559.449 324.392 562.767 321.344 566.779H317.32V584.008C317.32 591.795 322.433 599.583 332.68 605.423C353.193 617.279 386.422 617.279 406.935 605.423C417.182 599.544 422.296 591.776 422.296 584.008Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.296 579.862V562.632H418.271C415.218 558.626 411.355 555.31 406.935 552.898C386.422 541.062 353.193 541.062 332.68 552.898C328.26 555.31 324.398 558.626 321.344 562.632H317.32V579.862C317.32 587.649 322.433 595.436 332.68 601.276C353.193 613.132 386.422 613.132 406.935 601.276C417.182 595.397 422.296 587.629 422.296 579.862Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 597.13C398.792 597.13 422.296 583.541 422.296 566.779C422.296 550.017 398.792 536.428 369.798 536.428C340.804 536.428 317.3 550.017 317.3 566.779C317.3 583.541 340.804 597.13 369.798 597.13Z",
    fill: "url(#paint9_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.963 589.109C397.944 599.014 387.162 606.306 374.99 610.056C386.164 609.62 397.092 606.63 406.935 601.315C417.182 595.475 422.296 587.688 422.296 579.901V574.741C415.957 578.403 410.406 583.286 405.963 589.109Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.651 566.507V553.872H422.296C418.99 549.509 414.803 545.894 410.007 543.262C387.803 530.432 351.813 530.432 329.608 543.262C324.812 545.894 320.625 549.509 317.32 553.872H312.964V566.507C312.964 574.917 318.506 583.327 329.608 589.732C351.813 602.561 387.803 602.561 410.007 589.732C421.11 583.327 426.651 574.917 426.651 566.507Z",
    fill: "url(#paint10_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 586.734C401.186 586.734 426.632 572.021 426.632 553.872C426.632 535.723 401.186 521.01 369.798 521.01C338.409 521.01 312.964 535.723 312.964 553.872C312.964 572.021 338.409 586.734 369.798 586.734Z",
    fill: "url(#paint11_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.296 552.743V535.514H418.271C415.218 531.507 411.356 528.19 406.935 525.78C386.422 513.924 353.193 513.924 332.68 525.78C328.26 528.19 324.397 531.507 321.344 535.514H317.32V552.762C317.32 560.549 322.433 568.337 332.68 574.177C353.193 586.014 386.422 586.033 406.935 574.177C417.182 568.278 422.296 560.51 422.296 552.743Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.296 548.81V531.581H418.271C415.218 527.575 411.355 524.258 406.935 521.847C386.422 510.01 353.193 510.01 332.68 521.847C328.26 524.258 324.398 527.575 321.344 531.581H317.32V548.81C317.32 556.597 322.433 564.385 332.68 570.225C353.193 582.081 386.422 582.081 406.935 570.225C417.182 564.346 422.296 556.578 422.296 548.81Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 565.864C398.792 565.864 422.296 552.276 422.296 535.513C422.296 518.751 398.792 505.163 369.798 505.163C340.804 505.163 317.3 518.751 317.3 535.513C317.3 552.276 340.804 565.864 369.798 565.864Z",
    fill: "url(#paint12_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.963 556.227C394.744 570.536 379.092 576.571 368.029 579.102C382.047 579.375 396.222 576.455 406.916 570.264C417.163 564.423 422.276 556.636 422.276 548.849V541.88C415.945 545.535 410.4 550.412 405.963 556.227Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.651 535.241V522.626H422.296C418.988 518.27 414.801 514.662 410.007 512.035C387.803 499.186 351.813 499.186 329.608 512.035C324.814 514.662 320.627 518.27 317.32 522.626H312.964V535.26C312.964 543.671 318.506 552.081 329.608 558.505C351.813 571.335 387.803 571.335 410.007 558.505C421.11 552.061 426.651 543.651 426.651 535.241Z",
    fill: "url(#paint13_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 555.468C401.186 555.468 426.632 540.755 426.632 522.606C426.632 504.457 401.186 489.744 369.798 489.744C338.409 489.744 312.964 504.457 312.964 522.606C312.964 540.755 338.409 555.468 369.798 555.468Z",
    fill: "url(#paint14_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.296 521.497V504.267H418.271C415.218 500.261 411.355 496.944 406.935 494.533C386.422 482.697 353.193 482.697 332.68 494.533C328.26 496.944 324.398 500.261 321.344 504.267H317.32V521.497C317.32 529.284 322.433 537.071 332.68 542.911C353.193 554.767 386.422 554.767 406.935 542.911C417.182 537.032 422.296 529.264 422.296 521.497Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.296 516.668V499.439H418.271C415.224 495.427 411.36 492.11 406.935 489.705C386.345 477.849 353.29 477.849 332.68 489.647C328.256 492.051 324.392 495.369 321.344 499.381H317.32V516.61C317.32 524.397 322.433 532.184 332.68 538.025C353.193 549.881 386.422 549.881 406.935 538.025C417.182 532.204 422.296 524.436 422.296 516.668Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 534.618C398.792 534.618 422.296 521.03 422.296 504.267C422.296 487.505 398.792 473.917 369.798 473.917C340.804 473.917 317.3 487.505 317.3 504.267C317.3 521.03 340.804 534.618 369.798 534.618Z",
    fill: "url(#paint15_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.651 503.975V491.36H422.296C418.99 486.998 414.803 483.382 410.007 480.75C387.803 467.921 351.813 467.921 329.608 480.75C324.812 483.382 320.625 486.998 317.32 491.36H312.964V503.995C312.964 512.385 318.506 520.796 329.608 527.22C351.813 540.049 387.803 540.049 410.007 527.22C421.11 520.796 426.651 512.386 426.651 503.975Z",
    fill: "url(#paint16_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 524.222C401.186 524.222 426.632 509.509 426.632 491.36C426.632 473.211 401.186 458.498 369.798 458.498C338.409 458.498 312.964 473.211 312.964 491.36C312.964 509.509 338.409 524.222 369.798 524.222Z",
    fill: "url(#paint17_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 524.222C401.186 524.222 426.632 509.509 426.632 491.36C426.632 473.211 401.186 458.498 369.798 458.498C338.409 458.498 312.964 473.211 312.964 491.36C312.964 509.509 338.409 524.222 369.798 524.222Z",
    fill: "url(#paint18_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.963 523.346C393.655 539.076 375.961 544.761 364.917 546.883C379.928 547.7 395.425 544.78 406.935 538.122C417.182 532.282 422.296 524.495 422.296 516.707V508.92C415.954 512.603 410.404 517.506 405.963 523.346Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.651 503.975V491.36H422.296C418.99 486.998 414.803 483.382 410.007 480.75C387.803 467.921 351.813 467.921 329.608 480.75C324.812 483.382 320.625 486.998 317.32 491.36H312.964V503.995C312.964 512.385 318.506 520.796 329.608 527.22C351.813 540.049 387.803 540.049 410.007 527.22C421.11 520.796 426.651 512.386 426.651 503.975Z",
    fill: "url(#paint19_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 524.222C401.186 524.222 426.632 509.509 426.632 491.36C426.632 473.211 401.186 458.498 369.798 458.498C338.409 458.498 312.964 473.211 312.964 491.36C312.964 509.509 338.409 524.222 369.798 524.222Z",
    fill: "url(#paint20_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.798 524.222C401.186 524.222 426.632 509.509 426.632 491.36C426.632 473.211 401.186 458.498 369.798 458.498C338.409 458.498 312.964 473.211 312.964 491.36C312.964 509.509 338.409 524.222 369.798 524.222Z",
    fill: "url(#paint21_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.319 513.593C388.133 526.422 352.143 526.422 329.938 513.593C316.328 505.805 311.098 494.884 314.15 484.721C310.417 495.176 315.57 506.467 329.608 514.585C351.813 527.434 387.803 527.434 410.007 514.585C418.602 509.621 423.851 503.45 425.796 497.064C423.637 503.158 418.485 508.881 410.319 513.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.319 544.858C388.133 557.688 352.143 557.688 329.938 544.858C316.328 537.071 311.098 526.149 314.15 515.968C310.417 526.422 315.57 537.733 329.608 545.851C351.813 558.68 387.803 558.68 410.007 545.851C418.602 540.867 423.851 534.696 425.796 528.33C423.637 534.306 418.485 540.147 410.319 544.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.319 576.104C388.133 588.934 352.143 588.934 329.938 576.104C316.328 568.317 311.098 557.396 314.15 547.233C310.417 557.688 315.57 568.998 329.608 577.097C351.813 589.946 387.803 589.946 410.007 577.097C418.602 572.113 423.851 565.942 425.796 559.576C423.637 565.592 418.485 571.393 410.319 576.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.319 607.37C388.133 620.199 352.143 620.199 329.938 607.37C316.328 599.583 311.098 588.661 314.15 578.479C310.417 588.953 315.57 600.245 329.608 608.363C351.813 621.192 387.803 621.192 410.007 608.363C418.602 603.398 423.851 597.208 425.796 590.842C423.637 596.857 418.485 602.659 410.319 607.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M318.292 505.104H369.895V474.676H320.819C311.311 484.001 310.514 495.37 318.292 505.104Z",
    fill: "url(#paint22_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.983 488.284V481.743H396.747C395.055 479.501 392.908 477.644 390.447 476.292C379.053 469.712 360.562 469.712 349.168 476.292C346.708 477.644 344.561 479.501 342.869 481.743H340.613V488.226C340.613 492.548 343.471 496.869 349.168 500.16C360.562 506.74 379.053 506.74 390.447 500.16C396.066 496.928 398.983 492.606 398.983 488.284Z",
    fill: "url(#paint23_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.447 493.735C379.053 500.315 360.562 500.315 349.168 493.735C337.774 487.155 337.774 476.467 349.168 469.867C360.562 463.268 379.053 463.287 390.447 469.867C401.841 476.448 401.899 487.136 390.447 493.735Z",
    fill: "url(#paint24_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.447 493.735C379.053 500.315 360.562 500.315 349.168 493.735C337.774 487.155 337.774 476.467 349.168 469.867C360.562 463.268 379.053 463.287 390.447 469.867C401.841 476.448 401.899 487.136 390.447 493.735Z",
    fill: "url(#paint25_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7 489.842C379.395 492.03 374.636 493.171 369.808 493.171C364.98 493.171 360.22 492.03 355.915 489.842C353.839 488.751 352.123 487.081 350.976 485.033C349.032 481.139 353.932 478.375 359.221 475.299C366.881 470.86 372.326 469.77 380.006 474.209C385.275 477.246 390.622 481.159 388.639 485.014C387.484 487.06 385.771 488.734 383.7 489.842Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.915 480.244C360.221 478.06 364.981 476.921 369.808 476.921C374.635 476.921 379.394 478.06 383.7 480.244C385.771 481.334 387.485 482.996 388.639 485.033C390.583 481.139 388.989 476.798 383.7 473.742C379.393 471.562 374.634 470.426 369.808 470.426C364.981 470.426 360.223 471.562 355.915 473.742C350.627 476.798 348.993 481.159 350.977 485.033C352.132 482.997 353.846 481.335 355.915 480.244Z",
    fill: "url(#paint26_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.9 539.31C398.011 540.828 395.211 540.419 395.522 538.395C395.833 536.37 399.158 533.528 402.988 532.029C406.819 530.53 409.677 530.919 409.385 532.924C409.094 534.93 405.633 537.811 401.9 539.31Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.9 571.023C398.011 572.522 395.211 572.113 395.522 570.108C395.833 568.103 399.158 565.241 402.988 563.723C406.819 562.204 409.677 562.613 409.385 564.638C409.094 566.662 405.633 569.505 401.9 571.023Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.016 602.931C398.127 604.43 395.328 604.021 395.619 602.016C395.911 600.011 399.275 597.149 403.105 595.631C406.935 594.112 409.794 594.54 409.502 596.546C409.21 598.551 405.788 601.413 402.016 602.931Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.71 531.347C412.557 531.536 412.363 531.686 412.143 531.787C411.923 531.889 411.682 531.937 411.44 531.93C411.198 531.923 410.96 531.86 410.747 531.746C410.533 531.632 410.348 531.47 410.207 531.272C410.066 531.075 409.972 530.848 409.933 530.608C409.894 530.369 409.91 530.124 409.981 529.892C410.052 529.66 410.176 529.447 410.342 529.271C410.509 529.095 410.713 528.959 410.941 528.875C411.093 528.686 411.287 528.536 411.508 528.435C411.728 528.334 411.969 528.285 412.211 528.292C412.453 528.299 412.69 528.362 412.904 528.477C413.118 528.591 413.303 528.753 413.444 528.95C413.585 529.147 413.679 529.374 413.718 529.614C413.757 529.853 413.741 530.098 413.67 530.33C413.599 530.562 413.475 530.775 413.309 530.951C413.142 531.128 412.937 531.263 412.71 531.347Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.71 563.197C412.557 563.385 412.363 563.536 412.143 563.637C411.923 563.738 411.682 563.787 411.44 563.78C411.198 563.772 410.96 563.709 410.747 563.595C410.533 563.481 410.348 563.319 410.207 563.122C410.066 562.925 409.972 562.698 409.933 562.458C409.894 562.219 409.91 561.973 409.981 561.741C410.052 561.509 410.176 561.297 410.342 561.121C410.509 560.944 410.713 560.809 410.941 560.725C411.093 560.536 411.287 560.385 411.508 560.284C411.728 560.183 411.969 560.134 412.211 560.142C412.453 560.149 412.69 560.212 412.904 560.326C413.118 560.44 413.303 560.602 413.444 560.799C413.585 560.997 413.679 561.224 413.718 561.463C413.757 561.703 413.741 561.948 413.67 562.18C413.599 562.412 413.475 562.624 413.309 562.801C413.142 562.977 412.937 563.113 412.71 563.197Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.71 594.93C412.557 595.118 412.363 595.269 412.143 595.37C411.923 595.471 411.682 595.52 411.44 595.513C411.198 595.505 410.96 595.442 410.747 595.328C410.533 595.214 410.348 595.052 410.207 594.855C410.066 594.658 409.972 594.43 409.933 594.191C409.894 593.952 409.91 593.706 409.981 593.474C410.052 593.242 410.176 593.03 410.342 592.853C410.509 592.677 410.713 592.542 410.941 592.457C411.093 592.269 411.287 592.118 411.508 592.017C411.728 591.916 411.969 591.867 412.211 591.875C412.453 591.882 412.69 591.945 412.904 592.059C413.118 592.173 413.303 592.335 413.444 592.532C413.585 592.73 413.679 592.957 413.718 593.196C413.757 593.436 413.741 593.681 413.67 593.913C413.599 594.145 413.475 594.357 413.309 594.534C413.142 594.71 412.937 594.846 412.71 594.93Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.595 732.627C429.08 732.637 422.676 730.932 417.027 727.682L298.537 659.447C298.38 659.337 298.253 659.192 298.165 659.022C298.076 658.853 298.03 658.664 298.03 658.473C298.03 658.282 298.076 658.094 298.165 657.925C298.253 657.755 298.38 657.609 298.537 657.5L325.194 642.257C325.327 642.18 325.474 642.13 325.626 642.11C325.778 642.09 325.932 642.1 326.08 642.14C326.228 642.18 326.367 642.248 326.488 642.342C326.61 642.435 326.712 642.552 326.789 642.685C326.868 642.817 326.92 642.964 326.941 643.117C326.963 643.269 326.953 643.425 326.913 643.574C326.873 643.723 326.804 643.862 326.709 643.984C326.614 644.105 326.496 644.206 326.361 644.281L301.473 658.532L418.135 725.755C423.435 728.798 429.437 730.399 435.547 730.399C441.656 730.399 447.659 728.798 452.958 725.755L669.347 600.829C669.524 600.724 669.725 600.669 669.93 600.669C670.135 600.669 670.337 600.724 670.514 600.829L725.461 632.192C725.596 632.267 725.714 632.367 725.81 632.488C725.905 632.609 725.975 632.748 726.017 632.897C726.058 633.045 726.07 633.2 726.052 633.353C726.033 633.506 725.984 633.654 725.909 633.788C725.75 634.057 725.493 634.255 725.192 634.338C724.891 634.422 724.569 634.385 724.295 634.236L669.95 603.184L454.125 727.779C448.476 730.984 442.088 732.656 435.595 732.627Z",
    fill: "url(#paint27_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.317 621.543C798.063 621.544 797.815 621.463 797.611 621.31C797.407 621.158 797.259 620.943 797.188 620.698C797.118 620.453 797.129 620.192 797.221 619.955C797.312 619.717 797.478 619.516 797.695 619.382L1039.3 465.584L848.462 355.201C848.279 355.1 848.127 354.95 848.024 354.768C847.921 354.586 847.871 354.378 847.879 354.169C847.882 353.965 847.938 353.765 848.04 353.588C848.142 353.41 848.287 353.262 848.462 353.157L909.554 318.932C909.826 318.784 910.144 318.748 910.442 318.831C910.74 318.915 910.993 319.112 911.148 319.38C911.224 319.514 911.273 319.662 911.292 319.815C911.31 319.968 911.298 320.123 911.257 320.271C911.215 320.42 911.145 320.558 911.049 320.679C910.954 320.8 910.836 320.901 910.701 320.976L851.418 354.189L1042.14 464.455C1042.32 464.556 1042.46 464.701 1042.56 464.875C1042.67 465.049 1042.72 465.246 1042.72 465.448C1042.72 465.649 1042.67 465.847 1042.58 466.023C1042.48 466.2 1042.35 466.35 1042.18 466.46L798.958 621.348C798.77 621.479 798.546 621.547 798.317 621.543Z",
    fill: "url(#paint28_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.126 685.495C741.269 685.495 725.422 681.718 713.503 674.826C701.254 667.74 694.507 658.201 694.507 647.98C694.507 637.759 701.254 628.22 713.503 621.134C738.119 606.922 778.153 606.922 802.75 621.134C814.999 628.24 821.766 637.759 821.766 647.98C821.766 658.201 814.999 667.74 802.75 674.826C790.772 681.718 774.984 685.495 758.126 685.495ZM758.126 612.782C742.397 612.782 726.667 616.247 714.689 623.178C703.179 629.816 696.84 638.635 696.84 647.98C696.84 657.325 703.179 666.144 714.689 672.782C726.2 679.421 741.677 683.159 758.126 683.159C774.576 683.159 790.014 679.479 801.583 672.782C813.152 666.085 819.413 657.325 819.413 647.98C819.413 638.635 813.074 629.816 801.583 623.178C789.606 616.247 773.856 612.782 758.126 612.782Z",
    fill: "url(#paint29_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M758.127 674.807C783.759 674.807 804.539 662.796 804.539 647.98C804.539 633.164 783.759 621.153 758.127 621.153C732.494 621.153 711.715 633.164 711.715 647.98C711.715 662.796 732.494 674.807 758.127 674.807Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M814.98 627.753V615.118H810.605C807.305 610.751 803.117 607.134 798.317 604.508C776.132 591.679 740.141 591.679 717.937 604.508C713.137 607.134 708.949 610.751 705.648 615.118H701.332V627.753C701.332 636.163 706.873 644.573 717.976 650.978C740.18 663.827 776.17 663.827 798.356 650.978C809.419 644.573 814.98 636.163 814.98 627.753Z",
    fill: "url(#paint30_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 647.98C789.515 647.98 814.961 633.267 814.961 615.118C814.961 596.969 789.515 582.256 758.127 582.256C726.738 582.256 701.293 596.969 701.293 615.118C701.293 633.267 726.738 647.98 758.127 647.98Z",
    fill: "url(#paint31_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.625 614.631V597.402H806.6C803.539 593.395 799.67 590.079 795.245 587.668C774.751 575.812 741.502 575.812 721.009 587.668C716.583 590.079 712.714 593.395 709.654 597.402H705.629V614.631C705.629 622.419 710.762 630.206 721.009 636.046C741.502 647.883 774.751 647.883 795.245 636.046C805.492 630.167 810.625 622.399 810.625 614.631Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.625 610.485V593.256H806.6C803.539 589.249 799.67 585.932 795.245 583.522C774.751 571.666 741.502 571.666 721.009 583.522C716.583 585.932 712.714 589.249 709.654 593.256H705.629V610.485C705.629 618.272 710.762 626.059 721.009 631.9C741.502 643.736 774.751 643.736 795.245 631.9C805.492 626.02 810.625 618.252 810.625 610.485Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 627.753C787.121 627.753 810.625 614.164 810.625 597.402C810.625 580.64 787.121 567.052 758.127 567.052C729.133 567.052 705.629 580.64 705.629 597.402C705.629 614.164 729.133 627.753 758.127 627.753Z",
    fill: "url(#paint32_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.292 619.732C786.267 629.641 775.478 636.933 763.299 640.68C774.473 640.254 785.401 637.271 795.245 631.958C805.492 626.02 810.625 618.33 810.625 610.543V605.404C804.289 609.053 798.738 613.923 794.292 619.732Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M814.98 597.13V584.495H810.605C807.3 580.132 803.112 576.517 798.317 573.885C776.132 561.055 740.141 561.055 717.937 573.885C713.141 576.517 708.954 580.132 705.648 584.495H701.332V597.13C701.332 605.54 706.873 613.95 717.976 620.355C740.18 633.204 776.17 633.204 798.356 620.355C809.419 613.95 814.98 605.54 814.98 597.13Z",
    fill: "url(#paint33_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 617.357C789.515 617.357 814.961 602.644 814.961 584.495C814.961 566.346 789.515 551.633 758.127 551.633C726.738 551.633 701.293 566.346 701.293 584.495C701.293 602.644 726.738 617.357 758.127 617.357Z",
    fill: "url(#paint34_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.625 583.385V566.156H806.6C803.539 562.15 799.67 558.833 795.245 556.422C774.751 544.586 741.502 544.586 721.009 556.422C716.584 558.833 712.715 562.15 709.654 566.156H705.629V583.385C705.629 591.172 710.762 598.96 721.009 604.8C741.502 616.656 774.751 616.656 795.245 604.8C805.492 598.921 810.625 591.153 810.625 583.385Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.625 579.433V562.204H806.6C803.539 558.197 799.67 554.88 795.245 552.47C774.751 540.614 741.502 540.614 721.009 552.47C716.583 554.88 712.714 558.197 709.654 562.204H705.629V579.433C705.629 587.221 710.762 595.008 721.009 600.848C741.502 612.685 774.751 612.685 795.245 600.848C805.492 594.969 810.625 587.201 810.625 579.433Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 596.507C787.121 596.507 810.625 582.918 810.625 566.156C810.625 549.394 787.121 535.805 758.127 535.805C729.133 535.805 705.629 549.394 705.629 566.156C705.629 582.918 729.133 596.507 758.127 596.507Z",
    fill: "url(#paint35_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.292 586.87C782.995 601.16 767.44 607.195 756.357 609.745C770.376 610.018 784.551 607.078 795.245 600.907C805.492 595.066 810.625 587.279 810.625 579.492V572.464C804.282 576.136 798.73 581.033 794.292 586.87Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M814.98 565.864V553.249H810.605C807.305 548.881 803.117 545.265 798.317 542.639C776.132 529.809 740.141 529.809 717.937 542.639C713.137 545.265 708.949 548.881 705.648 553.249H701.332V565.864C701.332 574.274 706.873 582.684 717.976 589.109C740.18 601.938 776.17 601.938 798.356 589.109C809.419 582.684 814.98 574.274 814.98 565.864Z",
    fill: "url(#paint36_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 586.111C789.515 586.111 814.961 571.398 814.961 553.249C814.961 535.1 789.515 520.387 758.127 520.387C726.738 520.387 701.293 535.1 701.293 553.249C701.293 571.398 726.738 586.111 758.127 586.111Z",
    fill: "url(#paint37_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.625 552.12V534.89H806.6C803.539 530.883 799.67 527.567 795.245 525.156C774.751 513.3 741.502 513.3 721.009 525.156C716.583 527.567 712.714 530.883 709.654 534.89H705.629V552.12C705.629 559.907 710.762 567.694 721.009 573.534C741.502 585.371 774.751 585.371 795.245 573.534C805.492 567.655 810.625 559.887 810.625 552.12Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.625 547.311V530.062H806.6C803.539 526.055 799.67 522.739 795.245 520.328C774.751 508.472 741.502 508.472 721.009 520.328C716.583 522.739 712.714 526.055 709.654 530.062H705.629V547.311C705.629 555.098 710.762 562.885 721.009 568.726C741.502 580.582 774.751 580.582 795.245 568.726C805.492 562.827 810.625 555.079 810.625 547.311Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 565.241C787.121 565.241 810.625 551.653 810.625 534.89C810.625 518.128 787.121 504.54 758.127 504.54C729.133 504.54 705.629 518.128 705.629 534.89C705.629 551.653 729.133 565.241 758.127 565.241Z",
    fill: "url(#paint38_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.98 534.618V521.983H810.605C807.3 517.621 803.112 514.005 798.317 511.373C776.132 498.544 740.141 498.544 717.937 511.373C713.137 514 708.949 517.616 705.648 521.983H701.332V534.618C701.332 543.028 706.873 551.438 717.976 557.843C740.18 570.692 776.17 570.692 798.356 557.843C809.419 551.438 814.98 543.028 814.98 534.618Z",
    fill: "url(#paint39_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 554.845C789.515 554.845 814.961 540.132 814.961 521.983C814.961 503.834 789.515 489.121 758.127 489.121C726.738 489.121 701.293 503.834 701.293 521.983C701.293 540.132 726.738 554.845 758.127 554.845Z",
    fill: "url(#paint40_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 554.845C789.515 554.845 814.961 540.132 814.961 521.983C814.961 503.834 789.515 489.121 758.127 489.121C726.738 489.121 701.293 503.834 701.293 521.983C701.293 540.132 726.738 554.845 758.127 554.845Z",
    fill: "url(#paint41_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.292 553.989C781.965 569.699 764.291 575.403 753.247 577.506C768.257 578.324 783.754 575.403 795.245 568.765C805.492 562.827 810.625 555.137 810.625 547.35V539.563C804.277 543.236 798.724 548.141 794.292 553.989Z",
    fill: "#4DB483"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M814.98 534.618V521.983H810.605C807.3 517.621 803.112 514.005 798.317 511.373C776.132 498.544 740.141 498.544 717.937 511.373C713.137 514 708.949 517.616 705.648 521.983H701.332V534.618C701.332 543.028 706.873 551.438 717.976 557.843C740.18 570.692 776.17 570.692 798.356 557.843C809.419 551.438 814.98 543.028 814.98 534.618Z",
    fill: "url(#paint42_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 554.845C789.515 554.845 814.961 540.132 814.961 521.983C814.961 503.834 789.515 489.121 758.127 489.121C726.738 489.121 701.293 503.834 701.293 521.983C701.293 540.132 726.738 554.845 758.127 554.845Z",
    fill: "url(#paint43_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 554.845C789.515 554.845 814.961 540.132 814.961 521.983C814.961 503.834 789.515 489.121 758.127 489.121C726.738 489.121 701.293 503.834 701.293 521.983C701.293 540.132 726.738 554.845 758.127 554.845Z",
    fill: "url(#paint44_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.647 544.235C776.443 557.065 740.452 557.065 718.267 544.235C704.657 536.448 699.407 525.546 702.459 515.364C698.746 525.818 703.898 537.129 718.014 545.248C740.219 558.077 776.209 558.077 798.395 545.248C807.008 540.264 812.258 534.092 814.202 527.726C811.947 533.722 806.814 539.504 798.647 544.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.647 575.481C776.443 588.311 740.452 588.311 718.267 575.481C704.657 567.694 699.407 556.773 702.459 546.591C698.746 557.065 703.898 568.356 718.014 576.474C740.219 589.304 776.209 589.304 798.395 576.474C807.008 571.51 812.258 565.338 814.202 558.953C811.947 564.969 806.814 570.77 798.647 575.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.647 606.747C776.443 619.576 740.452 619.576 718.267 606.747C704.657 598.96 699.407 588.038 702.459 577.856C698.746 588.311 703.898 599.622 718.014 607.74C740.219 620.569 776.209 620.569 798.395 607.74C807.008 602.756 812.258 596.585 814.202 590.219C811.947 596.234 806.814 602.016 798.647 606.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.647 637.993C776.443 650.822 740.452 650.822 718.267 637.993C704.657 630.206 699.407 619.284 702.459 609.122C698.746 619.576 703.898 630.887 718.014 638.986C740.219 651.835 776.209 651.835 798.395 638.986C807.008 634.022 812.258 627.85 814.202 621.465C811.947 627.48 806.814 633.282 798.647 637.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M706.523 535.786H758.127V505.319H709.109C699.621 514.624 698.765 526.072 706.523 535.786Z",
    fill: "url(#paint45_linear_719_78054)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M787.312 518.907V512.424H785.076C783.38 510.184 781.225 508.332 778.757 506.993C767.363 500.393 748.891 500.393 737.497 506.993C735.028 508.332 732.874 510.184 731.178 512.424H728.942V518.907C728.942 523.229 731.8 527.551 737.497 530.841C748.891 537.441 767.363 537.441 778.757 530.841C784.473 527.551 787.312 523.229 787.312 518.907Z",
    fill: "url(#paint46_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 529.303C774.245 529.303 787.312 521.746 787.312 512.424C787.312 503.103 774.245 495.546 758.127 495.546C742.008 495.546 728.942 503.103 728.942 512.424C728.942 521.746 742.008 529.303 758.127 529.303Z",
    fill: "url(#paint47_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.127 529.303C774.245 529.303 787.312 521.746 787.312 512.424C787.312 503.103 774.245 495.546 758.127 495.546C742.008 495.546 728.942 503.103 728.942 512.424C728.942 521.746 742.008 529.303 758.127 529.303Z",
    fill: "url(#paint48_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.029 520.465C767.721 522.654 762.958 523.794 758.127 523.794C753.296 523.794 748.533 522.654 744.225 520.465C742.154 519.375 740.44 517.713 739.286 515.676C737.341 511.782 742.261 508.998 747.53 505.942C755.21 501.503 760.654 500.393 768.335 504.832C773.604 507.888 778.951 511.782 776.968 515.656C775.816 517.7 774.102 519.37 772.029 520.465Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.225 510.945C748.533 508.756 753.296 507.615 758.127 507.615C762.958 507.615 767.721 508.756 772.029 510.945C774.099 512.035 775.814 513.697 776.968 515.734C778.912 511.84 777.298 507.519 772.029 504.462C767.721 502.273 762.958 501.132 758.127 501.132C753.296 501.132 748.533 502.273 744.225 504.462C738.955 507.519 737.303 511.86 739.286 515.734C740.445 513.701 742.158 512.04 744.225 510.945Z",
    fill: "url(#paint49_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.131 569.933C786.242 571.451 783.442 571.043 783.734 569.037C784.026 567.032 787.389 564.151 791.22 562.652C795.05 561.153 797.908 561.542 797.597 563.567C797.286 565.592 793.961 568.434 790.131 569.933Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.131 601.646C786.242 603.145 783.442 602.756 783.734 600.731C784.026 598.707 787.389 595.864 791.22 594.346C795.05 592.827 797.908 593.256 797.597 595.261C797.286 597.266 793.961 600.128 790.131 601.646Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.345 633.593C786.456 635.112 783.656 634.703 783.948 632.678C784.24 630.654 787.603 627.811 791.434 626.312C795.264 624.813 798.122 625.203 797.811 627.208C797.5 629.213 794.175 632.055 790.345 633.593Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.039 561.99C800.76 562.095 800.457 562.121 800.165 562.062C799.872 562.004 799.602 561.865 799.384 561.661C799.167 561.457 799.011 561.196 798.934 560.907C798.858 560.619 798.863 560.314 798.951 560.029C799.038 559.743 799.204 559.488 799.429 559.292C799.654 559.096 799.929 558.968 800.223 558.92C800.518 558.873 800.819 558.91 801.094 559.025C801.369 559.141 801.606 559.332 801.778 559.576C801.988 559.996 802.028 560.482 801.891 560.931C801.753 561.38 801.448 561.76 801.039 561.99Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.039 593.84C800.76 593.945 800.457 593.97 800.165 593.912C799.872 593.854 799.602 593.715 799.384 593.511C799.167 593.306 799.011 593.045 798.934 592.757C798.858 592.468 798.863 592.164 798.951 591.879C799.038 591.593 799.204 591.338 799.429 591.142C799.654 590.946 799.929 590.817 800.223 590.77C800.518 590.723 800.819 590.759 801.094 590.875C801.369 590.991 801.606 591.182 801.778 591.426C801.988 591.846 802.028 592.331 801.891 592.781C801.753 593.23 801.448 593.609 801.039 593.84Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.039 625.572C800.76 625.678 800.457 625.703 800.165 625.645C799.872 625.587 799.602 625.448 799.384 625.243C799.167 625.039 799.011 624.778 798.934 624.49C798.858 624.201 798.863 623.897 798.951 623.611C799.038 623.326 799.204 623.071 799.429 622.875C799.654 622.679 799.929 622.55 800.223 622.503C800.518 622.456 800.819 622.492 801.094 622.608C801.369 622.724 801.606 622.915 801.778 623.158C801.988 623.579 802.028 624.064 801.891 624.513C801.753 624.963 801.448 625.342 801.039 625.572Z",
    fill: "#007534"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M609.947 379.263C609.748 379.26 609.554 379.207 609.383 379.108L559.393 351.307C559.21 351.204 559.058 351.054 558.953 350.873C558.847 350.692 558.791 350.486 558.79 350.276C558.807 350.085 558.87 349.901 558.976 349.741C559.081 349.582 559.224 349.451 559.393 349.361L805.705 211.916C805.883 211.816 806.084 211.763 806.289 211.763C806.493 211.763 806.694 211.816 806.872 211.916L915.756 275.83C915.891 275.905 916.01 276.006 916.104 276.127C916.199 276.249 916.269 276.388 916.309 276.537C916.349 276.686 916.358 276.842 916.337 276.994C916.315 277.147 916.264 277.294 916.184 277.426C916.026 277.691 915.771 277.884 915.474 277.964C915.176 278.044 914.859 278.005 914.59 277.855L806.328 214.292L562.426 350.276L610.472 377.063C610.743 377.215 610.943 377.468 611.031 377.766C611.118 378.065 611.085 378.386 610.938 378.66C610.836 378.835 610.691 378.981 610.518 379.087C610.345 379.192 610.149 379.253 609.947 379.263Z",
    fill: "url(#paint50_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M918.673 369.821L837.438 322.806C835.668 321.794 835.902 320.003 837.943 318.913L861.82 305.09L949.53 355.804L925.634 369.607C924.574 370.193 923.39 370.517 922.179 370.554C920.969 370.592 919.767 370.34 918.673 369.821Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.27 305.83V289.613H1007.88L949.316 255.758C948.429 255.361 947.461 255.175 946.489 255.215C945.517 255.256 944.568 255.522 943.717 255.992L885.386 289.691H859.156V305.966C859.19 306.252 859.294 306.525 859.461 306.76C859.627 306.995 859.85 307.184 860.109 307.31L944.106 355.863C944.993 356.261 945.961 356.447 946.933 356.406C947.905 356.366 948.854 356.1 949.705 355.629L1032.89 307.543C1033.24 307.393 1033.55 307.159 1033.79 306.86C1034.03 306.561 1034.19 306.207 1034.27 305.83Z",
    fill: "url(#paint51_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.125 339.627L860.128 291.073C858.689 290.256 858.884 288.796 860.537 287.842L943.717 239.756C944.567 239.281 945.516 239.012 946.489 238.972C947.461 238.931 948.43 239.12 949.316 239.522L1033.31 288.075C1034.75 288.912 1034.58 290.353 1032.9 291.307L949.725 339.393C948.877 339.874 947.927 340.146 946.953 340.186C945.979 340.227 945.01 340.035 944.125 339.627Z",
    fill: "url(#paint52_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.377 333.981L869.967 290.957C868.703 290.217 868.858 289.01 870.336 288.075L944.066 245.46C944.817 245.035 945.658 244.794 946.52 244.757C947.381 244.719 948.24 244.887 949.024 245.246L1023.47 288.289C1024.76 289.029 1024.58 290.236 1023.12 291.151L949.394 333.786C948.632 334.21 947.78 334.449 946.909 334.483C946.037 334.516 945.17 334.344 944.377 333.981Z",
    fill: "url(#paint53_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.611 330.379L876.208 290.84C875.042 290.158 875.178 288.99 876.539 288.212L944.378 249.042C945.072 248.658 945.847 248.441 946.639 248.407C947.432 248.373 948.222 248.524 948.947 248.847L1017.33 288.387C1018.5 289.068 1018.36 290.334 1017 291.034L949.258 330.185C948.556 330.589 947.767 330.817 946.958 330.851C946.149 330.885 945.344 330.723 944.611 330.379Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M945.155 319.691L894.718 290.489C893.843 289.983 893.96 289.107 894.952 288.543L944.922 259.652C945.433 259.369 946.004 259.209 946.588 259.185C947.172 259.161 947.753 259.275 948.286 259.516L998.723 288.718C999.598 289.224 999.481 290.081 998.489 290.665L948.519 319.536C948.009 319.822 947.44 319.985 946.856 320.012C946.272 320.039 945.689 319.929 945.155 319.691Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.155 287.043L937.145 282.43L941.519 279.899L949.511 284.513L945.155 287.043Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.01 286.382L952.019 291.015L947.644 288.484L955.655 283.87L960.01 286.382Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.328 288.095L938.972 290.606L934.597 288.095L938.972 285.564L943.328 288.095Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.435 296.816L954.061 299.347L941.461 292.066L945.836 289.535L958.435 296.816Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.711 157.134L878.347 117.614L946.711 78.0935L1015.09 117.614L946.711 157.134Z",
    fill: "url(#paint54_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.711 308.848L878.347 269.328L946.711 229.808L1015.09 269.328L946.711 308.848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1015.09 117.614V269.328L946.711 308.848V157.134L1015.09 117.614Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.347 117.614V269.328L946.711 308.848V157.134L878.347 117.614Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882.974 127.678V264.032L942.083 298.199V161.845L882.974 127.678Z",
    fill: "#009040"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1004.83 154.272V158.282L956.977 185.946V181.936L1004.83 154.272Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.83 171.228V175.239L956.977 202.903V198.892L1004.83 171.228Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.83 188.185V192.195L956.977 219.859V215.849L1004.83 188.185Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.83 205.142V209.133L956.977 236.816V232.806L1004.83 205.142Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.83 222.079V226.089L956.977 253.753V249.743L1004.83 222.079Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.83 239.035V243.046L956.977 270.71V266.699L1004.83 239.035Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.711 155.79L879.514 116.932L878.347 117.614L946.711 157.134L1015.09 117.614L1013.91 116.932L946.711 155.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M946.711 146.757H928.745L878.347 117.614L933.198 85.9001H946.711V146.757Z",
    fill: "url(#paint55_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.711 143.253L897.11 114.577L946.711 85.9001L996.331 114.596L946.711 143.253Z",
    fill: "url(#paint56_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.331 114.596V118.081L946.711 146.757V143.253L996.331 114.596Z",
    fill: "url(#paint57_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.11 114.577V118.081L946.711 146.757V143.253L897.11 114.577Z",
    fill: "url(#paint58_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.481 115.044L925.284 113.778L925.459 112.747L945.836 100.871L948.674 102.214L948.149 103.09L927.481 115.044Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.953 101.825L948.15 103.09L949.569 102.273L945.953 100.19L923.865 112.961L925.284 113.778L945.953 101.825Z",
    fill: "url(#paint59_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.15 118.879L931.953 117.614L932.128 116.582L952.505 104.706L955.344 106.069L954.819 106.945L934.15 118.879Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.622 105.68L954.819 106.945L956.238 106.127L952.622 104.044L930.534 116.796L931.953 117.614L952.622 105.68Z",
    fill: "url(#paint60_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.819 122.734L938.622 121.468L938.797 120.436L959.174 108.561L962.013 109.904L961.488 110.78L940.819 122.734Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.291 109.515L961.488 110.78L962.888 109.963L959.291 107.88L937.203 120.651L938.622 121.468L959.291 109.515Z",
    fill: "url(#paint61_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.488 126.569L945.291 125.303L945.466 124.272L965.843 112.396L968.682 113.739L968.157 114.635L947.488 126.569Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.96 113.35L968.157 114.635L969.557 113.798L965.96 111.715L943.872 124.486L945.291 125.303L965.96 113.35Z",
    fill: "url(#paint62_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.347 245.343L946.711 204.012V157.134L878.347 117.614V245.343Z",
    fill: "#009040"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M944.008 163.967C943.956 163.02 943.683 162.098 943.21 161.277C942.737 160.455 942.078 159.756 941.286 159.236C941.006 159.038 940.679 158.917 940.337 158.886C939.996 158.856 939.652 158.916 939.342 159.061L937.397 160.19H938.583C938.562 160.384 938.562 160.58 938.583 160.774C938.635 161.718 938.909 162.637 939.382 163.456C939.855 164.274 940.514 164.97 941.305 165.485C941.488 165.6 941.684 165.691 941.889 165.758L941.344 166.79L943.289 165.68C943.542 165.477 943.74 165.214 943.866 164.915C943.991 164.616 944.04 164.29 944.008 163.967Z",
    fill: "url(#paint63_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.064 165.096C942.064 166.829 940.858 167.529 939.342 166.673C938.545 166.156 937.881 165.458 937.405 164.636C936.928 163.814 936.653 162.891 936.6 161.942C936.6 160.21 937.806 159.509 939.303 160.385C940.105 160.893 940.774 161.585 941.254 162.405C941.735 163.224 942.012 164.147 942.064 165.096Z",
    fill: "url(#paint64_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.917 164.415C940.917 165.407 940.217 165.816 939.342 165.31C938.89 165.011 938.514 164.611 938.244 164.141C937.974 163.672 937.817 163.145 937.786 162.604C937.786 161.592 938.486 161.183 939.342 161.689C939.8 161.987 940.182 162.389 940.456 162.862C940.73 163.336 940.888 163.868 940.917 164.415Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.669 128.691C886.617 127.744 886.343 126.822 885.87 126.001C885.398 125.179 884.739 124.48 883.947 123.96C883.667 123.762 883.339 123.641 882.998 123.61C882.657 123.58 882.313 123.64 882.002 123.785L880.058 124.914H881.244C881.223 125.108 881.223 125.304 881.244 125.498C881.296 126.442 881.569 127.361 882.042 128.18C882.515 128.998 883.174 129.694 883.966 130.209C884.149 130.324 884.344 130.415 884.549 130.482L883.985 131.514L885.93 130.404C886.186 130.203 886.389 129.941 886.518 129.642C886.647 129.342 886.699 129.015 886.669 128.691Z",
    fill: "#E6F8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.725 129.82C884.725 131.553 883.519 132.253 882.002 131.397C881.21 130.877 880.551 130.178 880.079 129.356C879.606 128.534 879.332 127.613 879.28 126.666C879.28 124.934 880.505 124.233 882.002 125.109C882.797 125.621 883.459 126.316 883.932 127.135C884.406 127.954 884.677 128.875 884.725 129.82Z",
    fill: "url(#paint65_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.577 129.158C883.577 130.151 882.877 130.56 882.002 130.054C881.551 129.755 881.175 129.355 880.905 128.885C880.635 128.415 880.478 127.889 880.447 127.348C880.447 126.335 881.147 125.946 882.002 126.433C882.461 126.73 882.843 127.132 883.117 127.606C883.391 128.08 883.548 128.612 883.577 129.158Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.008 299.814C943.955 298.871 943.68 297.952 943.208 297.134C942.735 296.316 942.077 295.62 941.286 295.103C941.006 294.905 940.679 294.784 940.337 294.754C939.996 294.723 939.652 294.783 939.342 294.928L937.397 296.057H938.583C938.562 296.251 938.562 296.447 938.583 296.641C938.635 297.585 938.909 298.504 939.382 299.323C939.855 300.141 940.514 300.837 941.305 301.352C941.488 301.467 941.684 301.558 941.889 301.625L941.344 302.657L943.289 301.547C943.545 301.342 943.745 301.076 943.871 300.773C943.996 300.47 944.044 300.141 944.008 299.814Z",
    fill: "url(#paint66_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.064 300.963C942.064 302.696 940.858 303.397 939.342 302.54C938.553 302.018 937.898 301.318 937.429 300.496C936.959 299.675 936.689 298.754 936.639 297.809C936.639 296.077 937.844 295.376 939.342 296.232C940.135 296.751 940.795 297.45 941.268 298.272C941.74 299.094 942.013 300.016 942.064 300.963Z",
    fill: "url(#paint67_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.917 300.282C940.917 301.294 940.217 301.703 939.342 301.197C938.89 300.898 938.514 300.498 938.244 300.028C937.974 299.558 937.817 299.032 937.786 298.491C937.786 297.478 938.486 297.069 939.342 297.576C939.799 297.87 940.18 298.269 940.454 298.739C940.728 299.21 940.886 299.738 940.917 300.282Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.669 264.538C886.615 263.595 886.341 262.676 885.868 261.858C885.395 261.04 884.737 260.344 883.947 259.827C883.667 259.629 883.339 259.508 882.998 259.478C882.656 259.447 882.313 259.507 882.002 259.652L880.058 260.781H881.244C881.223 260.975 881.223 261.171 881.244 261.365C881.296 262.309 881.569 263.228 882.042 264.047C882.515 264.865 883.174 265.561 883.966 266.076C884.149 266.191 884.344 266.282 884.549 266.349L883.985 267.381L885.93 266.271C886.189 266.069 886.393 265.803 886.523 265.5C886.652 265.197 886.702 264.866 886.669 264.538Z",
    fill: "url(#paint68_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.725 265.648C884.725 267.381 883.519 268.082 882.002 267.225C881.211 266.704 880.553 266.005 880.081 265.183C879.608 264.362 879.334 263.441 879.28 262.494C879.28 260.762 880.505 260.061 882.002 260.937C882.797 261.449 883.459 262.144 883.932 262.963C884.406 263.782 884.677 264.703 884.725 265.648Z",
    fill: "url(#paint69_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.577 265.025C883.577 266.018 882.877 266.427 882.002 265.921C881.551 265.622 881.175 265.222 880.905 264.752C880.635 264.282 880.478 263.756 880.447 263.215C880.447 262.202 881.147 261.793 882.002 262.3C882.461 262.597 882.843 262.999 883.117 263.473C883.391 263.947 883.548 264.479 883.577 265.025Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M617.724 483.281L536.411 436.285C534.641 435.253 534.875 433.482 536.916 432.294L560.793 418.491L648.503 469.108L624.607 482.93C623.567 483.525 622.403 483.866 621.207 483.927C620.012 483.988 618.819 483.766 617.724 483.281Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.258 419.309V403.092H706.873L648.309 369.237C647.422 368.835 646.454 368.647 645.481 368.687C644.509 368.728 643.559 368.996 642.709 369.471L584.378 403.17H558.149V419.445C558.18 419.732 558.284 420.006 558.451 420.241C558.618 420.476 558.842 420.664 559.101 420.789L643.098 469.342C643.983 469.75 644.952 469.942 645.926 469.902C646.9 469.861 647.85 469.589 648.698 469.108L731.878 421.022C732.232 420.874 732.543 420.639 732.784 420.34C733.025 420.041 733.188 419.687 733.258 419.309Z",
    fill: "url(#paint70_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.118 453.144L559.121 404.591C557.682 403.754 557.877 402.313 559.529 401.36L642.709 353.254C643.557 352.773 644.507 352.501 645.481 352.461C646.455 352.42 647.424 352.612 648.309 353.02L732.306 401.574C733.744 402.391 733.569 403.851 731.897 404.805L648.717 452.891C647.869 453.369 646.92 453.641 645.948 453.685C644.975 453.729 644.006 453.544 643.118 453.144Z",
    fill: "url(#paint71_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.409 447.46L568.959 404.416C567.696 403.676 567.851 402.469 569.329 401.554L643.001 358.919C643.755 358.502 644.596 358.267 645.457 358.233C646.318 358.199 647.175 358.368 647.959 358.725L722.409 401.749C723.692 402.489 723.517 403.696 722.059 404.63L648.328 447.246C647.581 447.661 646.748 447.897 645.894 447.934C645.04 447.972 644.189 447.809 643.409 447.46Z",
    fill: "url(#paint72_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.604 443.858L575.201 404.319C574.034 403.637 574.17 402.372 575.531 401.671L643.273 362.521C643.966 362.133 644.741 361.913 645.535 361.879C646.328 361.845 647.119 361.998 647.842 362.326L716.226 401.924C717.392 402.606 717.256 403.774 715.895 404.552L648.173 443.722C647.474 444.097 646.697 444.304 645.904 444.327C645.111 444.351 644.324 444.19 643.604 443.858Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M644.148 433.073L593.711 403.871C592.836 403.384 592.953 402.508 593.944 401.924L643.915 373.053C644.424 372.765 644.995 372.603 645.58 372.579C646.165 372.555 646.747 372.671 647.278 372.917L697.715 402.119C698.59 402.625 698.473 403.501 697.482 404.066L647.512 433.073C646.991 433.339 646.415 433.478 645.83 433.478C645.245 433.478 644.669 433.339 644.148 433.073Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.148 400.522L636.137 395.889L640.512 393.358L648.503 397.992L644.148 400.522Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.003 399.861L651.012 404.474L646.637 401.963L654.647 397.33L659.003 399.861Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.32 401.554L637.965 404.085L633.59 401.554L637.965 399.043L642.32 401.554Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.428 410.295L653.053 412.807L640.454 405.526L644.829 403.014L657.428 410.295Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.704 270.613L577.34 231.092L645.704 191.553L714.087 231.092L645.704 270.613Z",
    fill: "url(#paint73_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.704 422.307L577.34 382.787L645.704 343.267L714.087 382.787L645.704 422.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M714.087 231.092V382.787L645.704 422.307V270.612L714.087 231.092Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.34 231.092V382.787L645.704 422.307V270.612L577.34 231.092Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.967 241.138V377.511L641.076 411.678V275.324L581.967 241.138Z",
    fill: "#009040"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M703.821 267.731V271.742L655.97 299.406V295.395L703.821 267.731Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.821 284.688V288.698L655.97 316.362V312.352L703.821 284.688Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.821 301.645V305.655L655.97 333.319V329.309L703.821 301.645Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.821 318.601V322.612L655.97 350.276V346.265L703.821 318.601Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.821 335.558V339.568L655.97 367.232V363.222L703.821 335.558Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.821 352.514V356.525L655.97 384.189V380.178L703.821 352.514Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.704 269.25L578.506 230.411L577.34 231.093L645.704 270.613L714.087 231.093L712.901 230.411L645.704 269.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M645.704 260.217H627.738L577.34 231.093L632.19 199.379H645.704V260.217Z",
    fill: "url(#paint74_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.704 256.732L596.103 228.056L645.704 199.379L695.324 228.056L645.704 256.732Z",
    fill: "url(#paint75_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.324 228.055V231.54L645.704 260.217V256.732L695.324 228.055Z",
    fill: "url(#paint76_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.103 228.055V231.54L645.704 260.217V256.732L596.103 228.055Z",
    fill: "url(#paint77_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.474 228.523L624.276 227.238L624.451 226.206L644.828 214.331L647.667 215.693L647.142 216.569L626.474 228.523Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.945 215.304L647.143 216.569L648.562 215.752L644.945 213.669L622.857 226.42L624.277 227.238L644.945 215.304Z",
    fill: "url(#paint78_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.143 232.358L630.946 231.092L631.121 230.061L651.498 218.185L654.337 219.528L653.812 220.405L633.143 232.358Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.614 219.139L653.811 220.405L655.231 219.587L651.614 217.504L629.526 230.275L630.946 231.092L651.614 219.139Z",
    fill: "url(#paint79_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.812 236.193L637.615 234.928L637.79 233.896L658.167 222.02L661.006 223.364L660.481 224.259L639.812 236.193Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.284 222.994L660.481 224.259L661.881 223.442L658.284 221.359L636.196 234.11L637.615 234.928L658.284 222.994Z",
    fill: "url(#paint80_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.481 240.048L644.284 238.763L644.459 237.751L664.836 225.875L667.675 227.218L667.15 228.094L646.481 240.048Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.953 226.829L667.15 228.094L668.55 227.277L664.953 225.194L642.865 237.965L644.284 238.782L664.953 226.829Z",
    fill: "url(#paint81_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.34 358.822L645.704 317.491V270.613L577.34 231.092V358.822Z",
    fill: "#009040"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M643.001 277.426C642.949 276.482 642.675 275.563 642.202 274.745C641.729 273.926 641.07 273.231 640.279 272.715C640.001 272.514 639.674 272.39 639.333 272.355C638.991 272.321 638.647 272.378 638.334 272.52L636.39 273.649H637.576C637.556 273.85 637.556 274.052 637.576 274.253C637.629 275.197 637.904 276.115 638.376 276.933C638.849 277.752 639.507 278.447 640.298 278.964C640.481 279.073 640.677 279.158 640.881 279.217L640.337 280.269L642.281 279.159C642.537 278.954 642.737 278.688 642.863 278.385C642.989 278.082 643.036 277.752 643.001 277.426Z",
    fill: "url(#paint82_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.057 278.555C641.057 280.308 639.851 281.008 638.335 280.132C637.545 279.616 636.889 278.92 636.42 278.101C635.95 277.282 635.68 276.364 635.632 275.421C635.632 273.688 636.837 272.968 638.335 273.844C639.127 274.359 639.787 275.054 640.26 275.873C640.733 276.692 641.006 277.611 641.057 278.555Z",
    fill: "url(#paint83_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.91 277.894C639.91 278.886 639.21 279.295 638.335 278.809C637.883 278.505 637.507 278.102 637.237 277.629C636.967 277.156 636.81 276.627 636.779 276.083C636.779 275.09 637.479 274.681 638.335 275.187C638.793 275.481 639.175 275.879 639.449 276.35C639.723 276.82 639.881 277.35 639.91 277.894Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.661 242.15C585.609 241.206 585.336 240.287 584.863 239.469C584.39 238.65 583.731 237.955 582.939 237.439C582.661 237.238 582.335 237.114 581.993 237.079C581.652 237.045 581.307 237.102 580.995 237.244L579.051 238.373H580.237C580.216 238.574 580.216 238.776 580.237 238.977C580.29 239.921 580.564 240.839 581.037 241.657C581.51 242.476 582.168 243.171 582.959 243.688C583.142 243.797 583.338 243.882 583.542 243.941L582.978 244.993L584.923 243.883C585.182 243.68 585.386 243.415 585.515 243.112C585.644 242.809 585.695 242.478 585.661 242.15Z",
    fill: "url(#paint84_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.717 243.279C583.717 245.032 582.512 245.732 580.995 244.856C580.203 244.341 579.544 243.645 579.071 242.827C578.598 242.008 578.325 241.089 578.273 240.145C578.273 238.412 579.498 237.712 580.995 238.568C581.788 239.083 582.448 239.778 582.921 240.597C583.394 241.416 583.667 242.335 583.717 243.279Z",
    fill: "url(#paint85_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.57 242.618C582.57 243.61 581.87 244.019 580.995 243.533C580.541 243.232 580.163 242.828 579.893 242.355C579.623 241.882 579.468 241.352 579.439 240.807C579.439 239.814 580.139 239.405 580.995 239.912C581.453 240.205 581.835 240.603 582.109 241.074C582.383 241.544 582.541 242.074 582.57 242.618Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.001 413.293C642.949 412.349 642.675 411.431 642.202 410.612C641.729 409.793 641.07 409.098 640.279 408.582C640.001 408.381 639.674 408.257 639.333 408.223C638.991 408.188 638.647 408.245 638.334 408.388L636.39 409.517H637.576C637.556 409.711 637.556 409.907 637.576 410.101C637.628 411.048 637.901 411.969 638.374 412.791C638.847 413.612 639.506 414.311 640.298 414.831C640.481 414.94 640.677 415.025 640.881 415.084L640.337 416.136L642.281 415.026C642.537 414.821 642.737 414.555 642.863 414.252C642.989 413.949 643.036 413.62 643.001 413.293Z",
    fill: "url(#paint86_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.057 414.423C641.057 416.175 639.851 416.876 638.335 416C637.546 415.482 636.891 414.785 636.422 413.967C635.952 413.148 635.682 412.231 635.632 411.288C635.632 409.556 636.837 408.835 638.335 409.711C639.127 410.226 639.787 410.921 640.26 411.74C640.733 412.559 641.006 413.478 641.057 414.423Z",
    fill: "url(#paint87_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.91 413.761C639.91 414.754 639.21 415.162 638.335 414.656C637.881 414.36 637.503 413.96 637.233 413.49C636.963 413.019 636.807 412.492 636.779 411.95C636.779 410.957 637.479 410.548 638.335 411.055C638.793 411.348 639.175 411.746 639.449 412.217C639.723 412.688 639.881 413.217 639.91 413.761Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.661 378.017C585.609 377.073 585.336 376.155 584.863 375.336C584.39 374.517 583.731 373.822 582.939 373.306C582.661 373.105 582.335 372.981 581.993 372.947C581.652 372.912 581.307 372.969 580.995 373.112L579.051 374.241H580.237C580.218 374.435 580.218 374.63 580.237 374.825C580.289 375.772 580.562 376.693 581.035 377.515C581.508 378.336 582.167 379.035 582.959 379.555C583.142 379.664 583.338 379.749 583.542 379.809L582.978 380.86L584.923 379.75C585.182 379.548 585.386 379.282 585.515 378.979C585.644 378.676 585.695 378.345 585.661 378.017Z",
    fill: "url(#paint88_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.717 379.147C583.717 380.899 582.512 381.6 580.995 380.723C580.203 380.208 579.544 379.512 579.071 378.694C578.598 377.875 578.325 376.956 578.273 376.012C578.273 374.28 579.498 373.559 580.995 374.435C581.788 374.95 582.448 375.645 582.921 376.464C583.394 377.283 583.667 378.202 583.717 379.147Z",
    fill: "url(#paint89_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.57 378.563C582.57 379.555 581.87 379.964 580.995 379.478C580.543 379.174 580.167 378.771 579.897 378.298C579.627 377.825 579.471 377.296 579.439 376.752C579.439 375.759 580.139 375.35 580.995 375.856C581.453 376.15 581.835 376.548 582.109 377.019C582.383 377.489 582.541 378.019 582.57 378.563Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M863.531 535.533L782.217 488.518C780.468 487.505 780.681 485.714 782.723 484.624L806.6 470.802L894.31 521.419L870.492 535.241C869.434 535.828 868.254 536.16 867.046 536.211C865.837 536.262 864.634 536.03 863.531 535.533Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.123 471.542V455.325H952.738L894.194 421.47C893.302 421.072 892.331 420.886 891.357 420.926C890.382 420.967 889.429 421.233 888.574 421.704L830.243 455.403H803.994V471.658C804.023 471.949 804.125 472.226 804.292 472.465C804.459 472.704 804.685 472.895 804.947 473.021L888.924 521.555C889.812 521.962 890.783 522.155 891.759 522.117C892.735 522.08 893.689 521.814 894.544 521.341L977.724 473.255C978.079 473.106 978.393 472.872 978.637 472.573C978.881 472.274 979.048 471.92 979.123 471.542Z",
    fill: "url(#paint90_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.982 505.377L805.005 456.824C803.566 456.006 803.741 454.546 805.394 453.592L888.574 405.506C889.428 405.031 890.38 404.763 891.356 404.722C892.332 404.682 893.303 404.87 894.193 405.273L978.171 453.826C979.609 454.663 979.434 456.104 977.782 457.057L894.602 505.104C893.751 505.586 892.8 505.861 891.824 505.908C890.849 505.956 889.875 505.774 888.982 505.377Z",
    fill: "url(#paint91_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.982 505.377L805.005 456.824C803.566 456.006 803.741 454.546 805.394 453.592L888.574 405.506C889.428 405.031 890.38 404.763 891.356 404.722C892.332 404.682 893.303 404.87 894.193 405.273L978.171 453.826C979.609 454.663 979.434 456.104 977.782 457.057L894.602 505.104C893.751 505.586 892.8 505.861 891.824 505.908C890.849 505.956 889.875 505.774 888.982 505.377Z",
    fill: "url(#paint92_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.274 499.692L814.844 456.649C813.561 455.928 813.716 454.702 815.194 453.787L888.924 411.171C889.675 410.746 890.516 410.505 891.378 410.468C892.239 410.431 893.098 410.599 893.882 410.957L968.332 454.001C969.615 454.721 969.46 455.948 967.982 456.863L894.252 499.498C893.494 499.915 892.65 500.151 891.786 500.184C890.922 500.218 890.062 500.05 889.274 499.692Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.469 496.091L821.066 456.551C819.899 455.87 820.055 454.702 821.396 453.904L889.138 414.754C889.831 414.365 890.606 414.145 891.4 414.112C892.193 414.078 892.984 414.231 893.707 414.559L962.11 454.098C963.277 454.78 963.121 456.045 961.78 456.746L894.038 495.896C893.345 496.284 892.57 496.504 891.776 496.538C890.983 496.572 890.192 496.419 889.469 496.091Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.013 452.755L882.022 448.122L886.377 445.61L894.388 450.224L890.013 452.755Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.887 452.093L896.877 456.727L892.521 454.196L900.513 449.562L904.887 452.093Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.205 453.806L883.83 456.318L879.475 453.806L883.83 451.275L888.205 453.806Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.293 462.528L898.918 465.059L886.338 457.778L890.694 455.247L903.293 462.528Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M979.143 433.521L943.425 433.735L894.193 405.273C893.304 404.87 892.332 404.682 891.356 404.722C890.38 404.763 889.428 405.031 888.574 405.506L838.682 434.358L804.033 434.552V455.636C804.091 455.894 804.207 456.135 804.372 456.341C804.537 456.546 804.747 456.712 804.986 456.824L888.963 505.377C889.853 505.78 890.825 505.968 891.8 505.928C892.776 505.887 893.729 505.618 894.582 505.143L977.762 457.057C978.072 456.907 978.347 456.695 978.571 456.434C978.795 456.173 978.964 455.868 979.065 455.539L979.143 433.521Z",
    fill: "#009040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.123 435.604V419.445H952.738L894.194 385.59C893.304 385.188 892.332 384.999 891.356 385.04C890.381 385.081 889.428 385.349 888.574 385.824L830.243 419.523H803.994V435.779C804.022 436.067 804.125 436.342 804.292 436.578C804.459 436.813 804.685 437.001 804.947 437.122L888.983 485.637C889.873 486.039 890.844 486.228 891.82 486.187C892.796 486.146 893.748 485.878 894.602 485.403L977.782 437.317C978.128 437.162 978.43 436.925 978.664 436.626C978.898 436.328 979.056 435.977 979.123 435.604Z",
    fill: "url(#paint93_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.982 469.439L805.005 420.886C803.566 420.049 803.741 418.608 805.394 417.635L888.574 369.568C889.426 369.089 890.379 368.818 891.356 368.777C892.332 368.737 893.305 368.928 894.193 369.335L978.171 417.888C979.609 418.706 979.434 420.166 977.782 421.12L894.602 469.205C893.747 469.676 892.794 469.942 891.819 469.983C890.845 470.023 889.874 469.837 888.982 469.439Z",
    fill: "url(#paint94_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.274 463.754L814.844 420.711C813.561 419.971 813.716 418.764 815.194 417.849L888.924 375.214C889.678 374.797 890.519 374.561 891.38 374.528C892.241 374.494 893.098 374.662 893.882 375.019L968.332 418.044C969.615 418.783 969.46 419.99 967.982 420.925L894.252 463.54C893.497 463.965 892.653 464.207 891.789 464.244C890.924 464.281 890.062 464.113 889.274 463.754Z",
    fill: "url(#paint95_linear_719_78054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.469 460.153L821.066 420.613C819.899 419.932 820.055 418.667 821.396 417.966L889.138 378.816C889.83 378.423 890.605 378.2 891.399 378.167C892.194 378.133 892.985 378.288 893.707 378.621L962.11 418.16C963.277 418.842 963.121 420.01 961.78 420.789L894.038 459.958C893.343 460.342 892.569 460.559 891.776 460.593C890.983 460.627 890.194 460.476 889.469 460.153Z",
    fill: "#FFCB05"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M907.324 406.231C905.532 406.437 903.875 407.081 902.576 408.078C901.278 409.075 900.401 410.376 900.064 411.805C892.552 409.345 884.52 408.161 876.481 408.328C868.443 408.496 860.574 410.013 853.378 412.78C858.703 411.75 864.251 411.581 869.706 412.283C883.159 412.209 896.344 415.833 907.08 422.555C906.604 419.86 905.981 417.004 905.915 414.021C905.82 411.369 906.296 408.734 907.321 406.233",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.704 412.281C877.485 413.295 884.81 416.029 890.854 420.177C896.897 424.324 901.42 429.72 903.912 435.757C905.602 434.53 906.786 432.916 907.311 431.123C905.885 429.458 904.32 427.871 902.629 426.373C894.024 418.742 882.406 413.748 869.834 412.279L869.712 412.275",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.704 412.281C869.704 412.281 869.716 412.292 869.721 412.296C882.828 413.659 894.984 418.785 903.94 426.725C905.219 427.855 906.413 429.022 907.527 430.22C907.919 428.143 907.654 425.865 907.239 423.428C896.64 416.315 883.354 412.369 869.704 412.281Z",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.202 497.248C230.411 497.454 228.754 498.098 227.455 499.095C226.157 500.092 225.28 501.393 224.943 502.822C217.431 500.362 209.399 499.178 201.36 499.346C193.321 499.513 185.453 501.03 178.257 503.797C183.581 502.767 189.13 502.598 194.585 503.3C208.037 503.226 221.222 506.85 231.959 513.573C231.482 510.877 230.859 508.021 230.793 505.038C230.699 502.386 231.174 499.752 232.2 497.25",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.582 503.298C202.364 504.312 209.689 507.046 215.732 511.194C221.776 515.341 226.298 520.737 228.791 526.774C230.481 525.547 231.664 523.933 232.189 522.14C230.763 520.475 229.199 518.888 227.507 517.39C218.903 509.759 207.284 504.766 194.713 503.296L194.59 503.292",
    fill: "#007534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.582 503.298C194.582 503.298 194.595 503.309 194.6 503.313C207.706 504.676 219.863 509.802 228.819 517.742C230.098 518.872 231.292 520.04 232.405 521.237C232.798 519.16 232.532 516.882 232.118 514.445C221.519 507.332 208.233 503.386 194.582 503.298Z",
    fill: "#007534"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_78054",
    x1: 353.24,
    y1: 257.301,
    x2: 1042.79,
    y2: 257.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_78054",
    x1: 550.927,
    y1: 182.898,
    x2: 642.84,
    y2: 182.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_78054",
    x1: 511.505,
    y1: 219.892,
    x2: 554.26,
    y2: 219.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_719_78054",
    x1: 305.148,
    y1: 579.203,
    x2: 108.363,
    y2: 576.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_719_78054",
    x1: 295.59,
    y1: 516.71,
    x2: 104.916,
    y2: 458.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_719_78054",
    x1: 295.153,
    y1: 557.269,
    x2: 120.723,
    y2: 554.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_719_78054",
    x1: 306.182,
    y1: 617.37,
    x2: 433.437,
    y2: 617.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_719_78054",
    x1: 312.925,
    y1: 597.122,
    x2: 426.651,
    y2: 597.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_719_78054",
    x1: 426.632,
    y1: 617.357,
    x2: 298.894,
    y2: 615.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_719_78054",
    x1: 422.296,
    y1: 597.13,
    x2: 304.303,
    y2: 595.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_719_78054",
    x1: 312.925,
    y1: 566.499,
    x2: 426.651,
    y2: 566.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_719_78054",
    x1: 426.632,
    y1: 586.734,
    x2: 298.894,
    y2: 584.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_719_78054",
    x1: 422.296,
    y1: 565.864,
    x2: 304.303,
    y2: 564.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_719_78054",
    x1: 312.925,
    y1: 535.265,
    x2: 426.651,
    y2: 535.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_719_78054",
    x1: 426.632,
    y1: 555.468,
    x2: 298.894,
    y2: 553.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_719_78054",
    x1: 422.296,
    y1: 534.618,
    x2: 304.303,
    y2: 532.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_719_78054",
    x1: 312.964,
    y1: 503.995,
    x2: 426.651,
    y2: 503.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_719_78054",
    x1: 426.632,
    y1: 524.222,
    x2: 298.894,
    y2: 522.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_719_78054",
    x1: 426.632,
    y1: 524.222,
    x2: 298.894,
    y2: 522.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_719_78054",
    x1: 312.925,
    y1: 503.987,
    x2: 426.651,
    y2: 503.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_719_78054",
    x1: 426.632,
    y1: 524.222,
    x2: 298.894,
    y2: 522.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_719_78054",
    x1: 358.477,
    y1: 521.239,
    x2: 363.296,
    y2: 420.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_719_78054",
    x1: 312.964,
    y1: 489.919,
    x2: 369.798,
    y2: 489.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_719_78054",
    x1: 340.593,
    y1: 488.227,
    x2: 398.983,
    y2: 488.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_719_78054",
    x1: 399.014,
    y1: 498.67,
    x2: 333.395,
    y2: 497.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_719_78054",
    x1: 364.003,
    y1: 497.139,
    x2: 366.476,
    y2: 445.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_719_78054",
    x1: 350.162,
    y1: 477.73,
    x2: 389.437,
    y2: 477.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_719_78054",
    x1: 298.044,
    y1: 666.663,
    x2: 726.06,
    y2: 666.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_719_78054",
    x1: 797.15,
    y1: 470.198,
    x2: 1042.72,
    y2: 470.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_719_78054",
    x1: 694.511,
    y1: 647.993,
    x2: 821.766,
    y2: 647.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_719_78054",
    x1: 701.293,
    y1: 627.753,
    x2: 814.98,
    y2: 627.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_719_78054",
    x1: 814.961,
    y1: 647.98,
    x2: 687.223,
    y2: 646.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_719_78054",
    x1: 810.625,
    y1: 627.753,
    x2: 692.632,
    y2: 626.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_719_78054",
    x1: 701.293,
    y1: 597.13,
    x2: 814.98,
    y2: 597.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_719_78054",
    x1: 814.961,
    y1: 617.357,
    x2: 687.223,
    y2: 615.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_719_78054",
    x1: 810.625,
    y1: 596.507,
    x2: 692.632,
    y2: 594.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_719_78054",
    x1: 701.293,
    y1: 565.876,
    x2: 814.98,
    y2: 565.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_719_78054",
    x1: 814.961,
    y1: 586.111,
    x2: 687.223,
    y2: 584.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_719_78054",
    x1: 810.625,
    y1: 565.241,
    x2: 692.632,
    y2: 563.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_719_78054",
    x1: 701.293,
    y1: 534.618,
    x2: 814.98,
    y2: 534.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_719_78054",
    x1: 814.961,
    y1: 554.845,
    x2: 687.223,
    y2: 553.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_719_78054",
    x1: 814.961,
    y1: 554.845,
    x2: 687.223,
    y2: 553.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_719_78054",
    x1: 701.293,
    y1: 534.618,
    x2: 814.98,
    y2: 534.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_719_78054",
    x1: 814.961,
    y1: 554.845,
    x2: 687.223,
    y2: 553.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_719_78054",
    x1: 746.806,
    y1: 551.862,
    x2: 751.625,
    y2: 450.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_719_78054",
    x1: 701.235,
    y1: 520.582,
    x2: 758.03,
    y2: 520.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_719_78054",
    x1: 728.922,
    y1: 518.918,
    x2: 787.312,
    y2: 518.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_719_78054",
    x1: 787.312,
    y1: 529.303,
    x2: 721.717,
    y2: 528.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_719_78054",
    x1: 752.313,
    y1: 527.771,
    x2: 754.789,
    y2: 475.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_719_78054",
    x1: 738.474,
    y1: 508.433,
    x2: 777.763,
    y2: 508.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_719_78054",
    x1: 558.801,
    y1: 295.532,
    x2: 916.348,
    y2: 295.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04F182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_719_78054",
    x1: 1034.27,
    y1: 356.412,
    x2: 837.481,
    y2: 353.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_719_78054",
    x1: 1024.71,
    y1: 293.869,
    x2: 834.04,
    y2: 235.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_719_78054",
    x1: 1024.34,
    y1: 334.487,
    x2: 849.9,
    y2: 332.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_719_78054",
    x1: 1015.09,
    y1: 157.134,
    x2: 861.42,
    y2: 154.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_719_78054",
    x1: 878.347,
    y1: 116.329,
    x2: 946.711,
    y2: 116.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_719_78054",
    x1: 936.838,
    y1: 140.65,
    x2: 941.042,
    y2: 52.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_719_78054",
    x1: 993.619,
    y1: 132.04,
    x2: 938.618,
    y2: 116.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_719_78054",
    x1: 897.067,
    y1: 130.698,
    x2: 946.626,
    y2: 130.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_719_78054",
    x1: 923.856,
    y1: 106.985,
    x2: 949.569,
    y2: 106.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_719_78054",
    x1: 930.525,
    y1: 110.829,
    x2: 956.238,
    y2: 110.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_719_78054",
    x1: 937.194,
    y1: 114.674,
    x2: 962.888,
    y2: 114.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_719_78054",
    x1: 943.863,
    y1: 118.51,
    x2: 969.557,
    y2: 118.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_719_78054",
    x1: 940.048,
    y1: 166.431,
    x2: 941.238,
    y2: 154.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_719_78054",
    x1: 936.598,
    y1: 163.523,
    x2: 942.064,
    y2: 163.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_719_78054",
    x1: 879.278,
    y1: 128.247,
    x2: 884.725,
    y2: 128.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_719_78054",
    x1: 937.436,
    y1: 298.724,
    x2: 944.008,
    y2: 298.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_719_78054",
    x1: 936.639,
    y1: 299.386,
    x2: 942.064,
    y2: 299.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_719_78054",
    x1: 880.097,
    y1: 263.448,
    x2: 886.669,
    y2: 263.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_719_78054",
    x1: 879.28,
    y1: 264.11,
    x2: 884.725,
    y2: 264.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_719_78054",
    x1: 733.258,
    y1: 469.907,
    x2: 536.473,
    y2: 467.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_719_78054",
    x1: 723.707,
    y1: 407.364,
    x2: 533.029,
    y2: 348.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_719_78054",
    x1: 723.271,
    y1: 447.94,
    x2: 548.9,
    y2: 445.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_719_78054",
    x1: 714.087,
    y1: 270.613,
    x2: 560.413,
    y2: 268.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_719_78054",
    x1: 577.34,
    y1: 229.798,
    x2: 645.704,
    y2: 229.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_719_78054",
    x1: 635.831,
    y1: 254.129,
    x2: 640.035,
    y2: 165.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_719_78054",
    x1: 692.612,
    y1: 245.499,
    x2: 637.611,
    y2: 230.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_719_78054",
    x1: 596.06,
    y1: 244.167,
    x2: 645.619,
    y2: 244.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_719_78054",
    x1: 622.849,
    y1: 220.454,
    x2: 648.562,
    y2: 220.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_719_78054",
    x1: 629.518,
    y1: 224.299,
    x2: 655.231,
    y2: 224.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_719_78054",
    x1: 636.187,
    y1: 228.144,
    x2: 661.881,
    y2: 228.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_719_78054",
    x1: 642.856,
    y1: 231.988,
    x2: 668.55,
    y2: 231.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_719_78054",
    x1: 639.041,
    y1: 279.909,
    x2: 640.235,
    y2: 267.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_719_78054",
    x1: 635.63,
    y1: 276.99,
    x2: 641.057,
    y2: 276.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_719_78054",
    x1: 581.702,
    y1: 244.633,
    x2: 582.895,
    y2: 232.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_719_78054",
    x1: 578.271,
    y1: 241.719,
    x2: 583.717,
    y2: 241.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_719_78054",
    x1: 639.041,
    y1: 415.776,
    x2: 640.235,
    y2: 403.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_719_78054",
    x1: 635.63,
    y1: 412.857,
    x2: 641.057,
    y2: 412.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_719_78054",
    x1: 581.702,
    y1: 380.5,
    x2: 582.895,
    y2: 368.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981487,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_719_78054",
    x1: 578.271,
    y1: 377.581,
    x2: 583.717,
    y2: 377.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_719_78054",
    x1: 979.123,
    y1: 522.122,
    x2: 782.316,
    y2: 519.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_719_78054",
    x1: 969.711,
    y1: 459.694,
    x2: 779.052,
    y2: 401.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_719_78054",
    x1: 969.711,
    y1: 459.694,
    x2: 779.052,
    y2: 401.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_719_78054",
    x1: 979.123,
    y1: 486.192,
    x2: 782.316,
    y2: 483.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_719_78054",
    x1: 969.574,
    y1: 423.67,
    x2: 778.911,
    y2: 364.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_719_78054",
    x1: 969.201,
    y1: 464.249,
    x2: 794.76,
    y2: 461.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997876,
    stopColor: "#009140"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_78054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1254.08,
    height: 745.488,
    fill: "white",
    transform: "translate(0 -12.7441)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_719_78054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1295.49,
    height: 745.488,
    fill: "white",
    transform: "translate(-41.416 -12.7441)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.61c0108f52c74549824d4107a1baa68d.svg";
export { ForwardRef as ReactComponent };